import { PDF_MAGIC } from '@onerepair/contract';

export async function looksLikePdf(file: File): Promise<boolean> {
  if (!/\.pdf$/i.test(file.name)) return false;
  try {
    const head = new Uint8Array(await file.slice(0, PDF_MAGIC.length).arrayBuffer());
    return String.fromCharCode(...head) === PDF_MAGIC;
  } catch {
    return false;
  }
}
